<template>
    <div>
        <div v-if="totalcomps===0">
            <div class="new-comp-hint has-background-info" :class="{gone: hidehint}">
                <svg class="hint-arrow-new-comp" xmlns="http://www.w3.org/2000/svg" width="34.412" height="41.6" viewBox="0 0 34.412 41.6"><g transform="translate(-41.654 -562)"><path d="M14357.613-620.8H14323.2l17.854,19.935Z" transform="translate(-14281.547 1204.465)" fill="#167df0"/><rect width="8.9" height="26.632" transform="translate(54.59 562)" fill="#167df0"/></g></svg>
                <span class="action-text has-text-white">
                    Add your first competition&nbsp;<strong>here</strong>
                </span>
                <b-button @click="hidehint=true" type="is-info" class="action-close" icon-left="close"></b-button>
            </div>
        </div>
        <div class="container">
            Dash Index
        </div>
    </div>
</template>

<script> 
export default {
    data: function() {
        return {
            hidehint: false,
            done: false
        }
    },
    name: 'DashIndex',
    computed: {
        totalcomps() {
            if(!this.$store.getters['backend/competitions'])
                return null
            
            return this.$store.getters['backend/competitions'].length
        }
    }
}
</script>

<style>
.hint-arrow-new-comp { 
    position: absolute;
    top: -2.75rem;
    right: 1.5rem;
    transform: rotate(180deg) scale(1.25);
    width: 3rem;
 }
.new-comp-hint { 
    position: absolute;
    top: 6.75rem;
    right: 4.5rem;
    /* margin-top: 3.75rem; */
    padding: 0.5rem 0rem 0.5rem 1rem;
    border-radius: 1rem;
    text-align: right; 
    display: flex; align-items: center;
    transition: all 0.25s;
    opacity: 1;
    pointer-events: all;
}
.new-comp-hint.gone { pointer-events: none; opacity: 0; }
.new-comp-hint .action-close {
    margin-left: 1rem;
}
.new-comp-hint .action-text {
    
}
@media (min-width: 512px ){
    .new-comp-hint { 
        
    }
}
</style>
